import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { response } from './interface';

@Injectable({
  providedIn: 'root'
})
export class NotesService {

  constructor(
    private http : HttpClient
  ) { }

  getNotes(modelId, modelName){
    let params : HttpParams = new HttpParams().set("modelId", modelId).set("modelName", modelName);
    return this.http.get<response>(environment.url + "notes", {params : params});
  }

  getNote(id){
    let params : HttpParams = new HttpParams().set("id", id);
    return this.http.get<response>(environment.url + "note", {params : params});
  }

  saveNote(data){
    return this.http.post<response>(environment.url + "notes", data);
  }

}
